import { getStoredAuthToken } from "../utils/authTokenStorage";
import queryKeys from "./queryKeys";
import { queryClient } from "./queryClient";
import api from "../services/api";

const hasAuth = () => Boolean(getStoredAuthToken());

const prefetchUsers = (companyId) =>
  queryClient.prefetchInfiniteQuery(
    queryKeys.users.list(companyId, { searchParam: "" }),
    async ({ pageParam = 1 }) => {
      const { data } = await api.get("/users/", {
        params: { searchParam: "", pageNumber: pageParam },
      });
      return {
        users: data.users || [],
        hasMore: Boolean(data.hasMore),
      };
    }
  );

const prefetchQueues = (companyId) =>
  queryClient.prefetchQuery(queryKeys.queues.list(companyId), async () => {
    const { data } = await api.get("/queue");
    return data || [];
  });

const prefetchQuickMessages = (companyId) =>
  queryClient.prefetchInfiniteQuery(
    queryKeys.quickMessages.list(companyId, { searchParam: "" }),
    async ({ pageParam = 1 }) => {
      const { data } = await api.get("/quick-messages", {
        params: { searchParam: "", pageNumber: pageParam },
      });
      return {
        records: data.records || [],
        hasMore: Boolean(data.hasMore),
      };
    }
  );

const prefetchPrompts = (companyId) =>
  queryClient.prefetchQuery(queryKeys.prompts.list(companyId), async () => {
    const { data } = await api.get("/prompt");
    return data.prompts || [];
  });

export const prefetchCriticalAdminData = async ({ companyId, canPrefetch = () => false }) => {
  if (!hasAuth() || !companyId || !canPrefetch()) {
    return;
  }

  const tasks = [
    () => prefetchUsers(companyId),
    () => prefetchQueues(companyId),
    () => prefetchQuickMessages(companyId),
    () => prefetchPrompts(companyId),
  ];

  for (const task of tasks) {
    if (!hasAuth() || !canPrefetch()) return;
    try {
      await task();
    } catch (_error) {
      // best-effort prefetch
    }
  }
};
